import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Modal from 'shared/components/modal';
import BackgroundImage from 'shared/img/transfer-deadline-education-modal-image.svg';
import {Store} from 'src/types/store';

import {closeModal as closeModalAction} from 'shared/actions/modal';
import {dismissDeadlineModal} from './actions';

export const TRANSFER_EDUCATION_DEADLINE_MODAL_IDENTIFIER = 'transfer-education-deadline-modal';

const TransferDeadlineEducationModal = () => {
  const dispatch = useDispatch();

  const student = useSelector((state: Store) => state.student);

  const showTransferEducationDeadlineModal = useSelector(
    (state: Store) => state.showTransferEducationDeadlineModal
  );

  const modal = useSelector(
    (state: Store) => state.modal[TRANSFER_EDUCATION_DEADLINE_MODAL_IDENTIFIER]
  );

  const show = (showTransferEducationDeadlineModal && modal !== false) || modal === true;

  const closeModal = () => {
    dispatch(closeModalAction(TRANSFER_EDUCATION_DEADLINE_MODAL_IDENTIFIER));
    dispatch(dismissDeadlineModal(student._id));
  };

  return (
    <Modal show={show} onClose={closeModal}>
      <Modal.ImageHeader
        onClose={closeModal}
        backgroundImage={BackgroundImage}
        backgroundColor="m400"
        color="white"
      >
        Is your Planned Transfer Term up to date?
      </Modal.ImageHeader>

      <Modal.Body>
        <p>
          Your Planned Transfer Term determines the Earnings Deadlines that apply to you for your
          followed colleges. Let’s make sure your Planned Transfer Term is up to date so you can
          earn for as long as possible based on when you plan to apply.
        </p>
        <div>
          Current Transfer Term: {student.communityCollegeInfo?.transferSemester}{' '}
          {student.communityCollegeInfo?.transferYear}
        </div>
      </Modal.Body>

      <Modal.Footer
        primaryButton={{
          text: 'No, Update Term',
          onClick: closeModal,
          width: 120,
        }}
        secondaryButton={{
          text: 'Looks Good',
          onClick: closeModal,
          width: 120,
        }}
      />
    </Modal>
  );
};

export default TransferDeadlineEducationModal;
